import { LearningTrack, LearningTrackStep, LatestTrackStep } from "../../../interfaces/LearningTrack"

class LearningTracksAction {

  static REQUEST_LEARNING_TRACKS = 'REQUEST_LEARNING_TRACKS'
  static RECEIVE_LEARNING_TRACKS = 'RECEIVE_LEARNING_TRACKS'

  static RECEIVE_LATEST_TRACK_STEP = 'RECEIVE_LATEST_TRACK_STEP'

  static REQUEST_LEARNING_TRACK_STEPS = 'REQUEST_LEARNING_TRACK_STEPS'
  static RECEIVE_LEARNING_TRACK_STEPS = 'RECEIVE_LEARNING_TRACK_STEPS'

  static REQUEST_LEARNING_TRACK_STEP = 'REQUEST_LEARNING_TRACK_STEP'
  static RECEIVE_LEARNING_TRACK_STEP = 'RECEIVE_LEARNING_TRACK_STEP'

  static MARK_LEARNING_TRACK_STEP_AS_COMPLETE = 'MARK_LEARNING_TRACK_STEP_AS_COMPLETE'
  static REJECT_LEARNING_TRACK_STEP_AS_COMPLETE = 'REJECT_LEARNING_TRACK_STEP_AS_COMPLETE'

  static UNDO_MARK_LEARNING_TRACK_STEP_AS_COMPLETE = 'UNDO_MARK_LEARNING_TRACK_STEP_AS_COMPLETE';

  static SET_INTRO_MODAL_STATUS = 'SET_INTRO_MODAL_STATUS';
  static SET_INTRO_MODAL_VIEWED = 'SET_INTRO_MODAL_VIEWED';

  static CHECK_TRACK_COMPLETE_MODAL_STATUS = 'CHECK_TRACK_COMPLETE_MODAL_STATUS';
  static SET_TRACK_COMPLETE_MODAL_VIEWED = 'SET_TRACK_COMPLETE_MODAL_VIEWED';

  static SET_ORG_ADMIN_STATUS = 'SET_ORG_ADMIN_STATUS';

  static requestLearningTracks = () => ({
    type: LearningTracksAction.REQUEST_LEARNING_TRACKS,
  })

  static receiveLearningTracks = (tracks: LearningTrack[]) => ({
    type: LearningTracksAction.RECEIVE_LEARNING_TRACKS,
    payload: {
      learningTracks: tracks
    }
  })

  static requestLearningTrackSteps = (trackId: number) => ({
    type: LearningTracksAction.REQUEST_LEARNING_TRACK_STEPS,
    payload: {
      trackId
    }
  })

  static receiveLatestTrackStep = (track: LatestTrackStep) => ({
    type: LearningTracksAction.RECEIVE_LATEST_TRACK_STEP,
    payload: {
      latestTrackStep: track
    }
  })

  static receiveLearningTrackSteps = (trackId: number, steps: LearningTrackStep[]) => ({
    type: LearningTracksAction.RECEIVE_LEARNING_TRACK_STEPS,
    payload: {
      trackId,
      steps
    }
  })

  static requestLearningTrackStep = (stepId: number) => ({
    type: LearningTracksAction.REQUEST_LEARNING_TRACK_STEP,
    payload: {
      stepId
    }
  })

  static receiveLearningTrackStep = (trackId: number, step: LearningTrackStep) => ({
    type: LearningTracksAction.RECEIVE_LEARNING_TRACK_STEP,
    payload: {
      trackId,
      step
    }
  })

  static markLearningTrackStepAsComplete = (track: LearningTrack, step: LearningTrackStep) => ({
    type: LearningTracksAction.MARK_LEARNING_TRACK_STEP_AS_COMPLETE,
    payload: {
      track,
      step
    }
  })


  static undoMarkLearningTrackStepAsComplete = (track: LearningTrack, step: LearningTrackStep) => ({
    type: LearningTracksAction.UNDO_MARK_LEARNING_TRACK_STEP_AS_COMPLETE,
    payload: {
      track,
      step
    }
  })

  static rejectLearningTrackStepAsComplete = (track: LearningTrack, step: LearningTrackStep) => ({
    type: LearningTracksAction.REJECT_LEARNING_TRACK_STEP_AS_COMPLETE,
    payload: {
      track,
      step
    }
  })

  static setIntroModalStatus = (showIntroModal: boolean) => ({
    type: LearningTracksAction.SET_INTRO_MODAL_STATUS,
    payload: {
      showIntroModal
    }
  })

  static setIntroModalViewed = () => ({
    type: LearningTracksAction.SET_INTRO_MODAL_VIEWED,
    payload: {
      
    }
  })

  // Track complete modal
  static checkTrackCompleteModalStatus = (status: boolean) => ({
    type: LearningTracksAction.CHECK_TRACK_COMPLETE_MODAL_STATUS,
    payload: {
      status
    }
  })

  static setTrackCompleteModalViewed = () => ({
    type: LearningTracksAction.SET_TRACK_COMPLETE_MODAL_VIEWED,
    payload: {
      
    }
  })

  // Org admin
  static setOrgAdminStatus = (status: boolean) => ({
    type: LearningTracksAction.SET_ORG_ADMIN_STATUS,
    payload: {
      status
    }
  })


}

export default LearningTracksAction